import { Button, Dialog } from '@noorden-insurtech/alba-design-system';
import { useNavigate } from '@tanstack/react-router';
import { TriangleAlert } from 'lucide-react';

interface PropertyDeniedDialogProps {
  isOpen: boolean;
  detail?: string;
  errors: string[];
}

export function PropertyDeniedDialog({
  isOpen,
  detail,
  errors,
}: PropertyDeniedDialogProps) {
  const navigate = useNavigate();

  const handleConfirm = () => {
    navigate({ to: '/quotes' });
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={() => {}}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='max-w-lg'>
          <Dialog.Header>
            <Dialog.Title>
              <div className='flex items-center gap-3'>
                <TriangleAlert className='h-6 w-6' />
                Cotação encerrada
              </div>
            </Dialog.Title>
          </Dialog.Header>
          <Dialog.Body className='space-y-3'>
            {detail && (
              <p className='text-alba-gray-700 font-medium'>{detail}</p>
            )}
            {errors.length > 0 && (
              <ul className='px-3 space-y-2'>
                {errors.map(error => (
                  <li
                    key={error}
                    className='text-alba-gray-700 list-disc list-inside'
                  >
                    {error}
                  </li>
                ))}
              </ul>
            )}
            <p className='text-alba-gray-700'>
              Esta cotação foi encerrada automaticamente e você será
              redirecionado para a lista de cotações.
            </p>
          </Dialog.Body>
          <Dialog.Footer>
            <Button variant='primary' size='md' onClick={handleConfirm}>
              Ir para cotações
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
